/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { UserRestService } from '@gh/builder-shared-data';
import { FinderDialogConfig } from '@gh/common-internal-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { UserFinderFilter, UserFinderListItem } from './user-finder.model';

export interface UserFinderDialogConfig extends FinderDialogConfig {
  filter?: UserFinderFilter;
  preselected: ID[];
}

@Injectable()
export class UserFinderBusinessService {
  constructor(private userRest: UserRestService) {

  }

  findAllAsDataSource(filter: UserFinderFilter = {}): SlicedDataSource<UserFinderListItem> {
    return this.userRest.findAllAsDataSource(filter);
  }
}
